// Saved properties – backend API (client only). Uses /api/clients/saved.

import api from './api';

/**
 * Get saved properties from the backend
 * @returns {Promise<{ savedPropertyIds: string[], properties: object[] }>}
 */
export const getSavedPropertiesFromAPI = async () => {
  try {
    const res = await api.get('/api/clients/saved');
    const savedPropertyIds = res.data?.savedPropertyIds ?? [];
    const properties = res.data?.properties ?? [];
    return { savedPropertyIds: Array.isArray(savedPropertyIds) ? savedPropertyIds : [], properties };
  } catch (err) {
    console.error('Error fetching saved properties:', err);
    return { savedPropertyIds: [], properties: [] };
  }
};

/**
 * Add a property to saved list
 * @param {string} propertyId - Property ID (MongoDB _id or string)
 * @returns {Promise<{ savedPropertyIds: string[] }>}
 */
export const addSavedPropertyAPI = async (propertyId) => {
  const id = String(propertyId ?? '').trim();
  if (!id) return { savedPropertyIds: [] };
  const res = await api.post(`/api/clients/saved/${id}`);
  return { savedPropertyIds: res.data?.savedPropertyIds ?? [] };
};

/**
 * Remove a property from saved list
 * @param {string} propertyId - Property ID
 * @returns {Promise<{ savedPropertyIds: string[] }>}
 */
export const removeSavedPropertyAPI = async (propertyId) => {
  const id = String(propertyId ?? '').trim();
  if (!id) return { savedPropertyIds: [] };
  const res = await api.delete(`/api/clients/saved/${id}`);
  return { savedPropertyIds: res.data?.savedPropertyIds ?? [] };
};

/**
 * Toggle saved state via API
 * @param {string} propertyId - Property ID
 * @param {boolean} currentlySaved - Current saved state
 * @returns {Promise<boolean>} New saved state (true = saved, false = unsaved)
 */
export const toggleSavedPropertyAPI = async (propertyId, currentlySaved) => {
  if (currentlySaved) {
    await removeSavedPropertyAPI(propertyId);
    return false;
  }
  await addSavedPropertyAPI(propertyId);
  return true;
};

// Legacy helpers for components that only need IDs (e.g. sync check).
// Prefer loading savedPropertyIds from API once and passing down.
export const getSavedProperties = (userId) => {
  if (!userId) return [];
  return [];
};

export const saveProperty = (userId, propertyId) => {
  if (!userId || !propertyId) return false;
  return false;
};

export const unsaveProperty = (userId, propertyId) => {
  if (!userId || !propertyId) return false;
  return false;
};

export const toggleSavedProperty = (userId, propertyId) => {
  if (!userId || !propertyId) return false;
  return false;
};

export const isPropertySaved = (userId, propertyId) => {
  if (!userId || !propertyId) return false;
  return false;
};
